import React, { useEffect, useState } from "react";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";

import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";

const LoanAssignmentPage = ({
  setLoanAssignment,
  setOpenLoanDetailsDrawer,
  openLoanDetailsDrawer
}) => {
  const [searchText, setSearchText] = useState("");

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "rgba(0,0,0, .1)",
      color: theme.palette.common.black,
      fontWeight: "bold",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 25,
      fontWeight: "600",
    },
  }));

  const handleInputChange = (e) => {
    setSearchText(e.target.value);
  }

  return (
    <Box className="loan-assignment-container">
      <Box className="d-flex justify-content-between">
        <Typography
          sx={{
            fontFamily: "'Nunito'",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "21.4825px",
            color: "#3A3A3A",
          }}
          className=""
        >
          Loan Assignment
        </Typography>
        <Box>
          <Button
            className="fs-size-12 paiy-blue text-white"
            variant="contained"
            color="primary"
            onClick={() => setLoanAssignment(false)}
          >
            Return
          </Button>
        </Box>
      </Box>

      <Box>
        <Box className="search-container">
          <TextField
            placeholder="Name, email, etc."
            value={searchText}
            onChange={handleInputChange}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                // fetchMoneyGramUsers(); 
              }
            }}
            variant="standard"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                borderRadius: "33px",
                color: "#000",
              },
            }}
            sx={{
              "& .MuiInputBase-root": {},
              "& .MuiInputBase-input": {
                fontSize: "14px",
              },
            }}
          />
        </Box>
      </Box>

      <Box className="mt-4">
        <TableContainer >
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Request</StyledTableCell>
                <StyledTableCell>Loan ID</StyledTableCell>
                <StyledTableCell>Requested Amount</StyledTableCell>
                <StyledTableCell>Request Date</StyledTableCell>
                <StyledTableCell>Approval Date</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={1}>
                <TableCell align="left" className="">
                  <div>Cell</div>
                </TableCell>
                <TableCell align="left" className="">
                  <div>1111</div>
                </TableCell>
                <TableCell align="left" className="">
                  <div>1000</div>
                </TableCell>
                <TableCell align="left" className="">
                  <div>12-06-2025</div>
                </TableCell>
                <TableCell align="left" className="">
                  <div>19-06-2025</div>
                </TableCell>
                <TableCell align="left" className="d-flex gap-2">
                  <Button
                    onClick={() => setOpenLoanDetailsDrawer(true)}
                    variant="contained"
                    size="small"
                  >
                    Manage
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default LoanAssignmentPage;
